module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f021-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cn"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _c('br'), _vm._v("3")]), _vm._v(" "), _c('p', {
    staticClass: "cit"
  }, [_c('span', {
    staticClass: "first-line"
  }, [_c('em', [_vm._v("Umber preferred not to disrupt the")])]), _vm._v(" bustling harbor of Kurahaven by riding in on the back of a gargantuan sea-beast. Miles from the city they met with the "), _c('em', [_vm._v("Bounder")]), _vm._v(", a ship from Umber’s merchant fleet—dashing vessels of daring design that could outsail anything the world had known. The "), _c('em', [_vm._v("Bounder")]), _vm._v(" was captained by Sandar, half brother to Nima. From that rendezvous it was only a few hours’ sail into Kurahaven. A savage storm had caused great destruction just a few weeks before, smashing the wharf into splinters and driving ships into the streets. Every vessel in the harbor had been damaged in the tempest, but the "), _c('em', [_vm._v("Bounder")]), _vm._v(" had been on a journey of commerce when it struck, and so was spared.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Dozens of boats of all sizes were usually cutting across the bay at all times, but when the "), _c('em', [_vm._v("Bounder")]), _vm._v(" sailed in, she was among a lonely three. Things were far busier on the shore, where thousands of people were occupied with repairs to the city and waterfront. Kurahaven was the wealthy capital of a prosperous country and so possessed the resources to rebuild its glory. Craftsmen who’d journeyed to Kurahaven from a hundred miles around hammered on the walls and roofs of the buildings; they pulled the pieces off damaged ships, cannibalizing the useful planks, beams, cords, and sails; they constructed new docks, which reached even farther into the waves. On the long hill beyond the city Hap saw rolling wagons laden with lumber and bricks. Even a half mile away he could hear saws and hammers and smell paint and sawdust.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The "), _c('em', [_vm._v("Bounder")]), _vm._v(" sidled up to one of the few surviving berths, scraping past a similar vessel that lay half sunk on its side. “Poor "), _c('em', [_vm._v("Swift")]), _vm._v(",” Sandar said, bowing his head. The "), _c('em', [_vm._v("Swift")]), _vm._v(" was his usual command, but the sleek ship had fallen prey to the storm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Once Sandar’s men had secured the "), _c('em', [_vm._v("Bounder")]), _vm._v(" to the dock, an anxious Umber scurried down the plank, waving for the others to hurry after him. A carriage waited. “Hoyle is hunting for you,” the driver called to Umber. It was Dodd, one of Umber’s servants and guards.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“I know—I saw her coming!” Umber cried. “Who knew ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("she could move that fast? Get in, everyone!” Even the rickety Balfour practically broke into a sprint, and they piled into the carriage, with Oates climbing atop beside Dodd. Hap exhaled deeply as the carriage lurched into motion. Like the others he had no desire to be in the vicinity when Hoyle unleashed her wrath on Umber.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Hoyle was the short, squat, iron-willed woman who ran Umber’s business ventures. While she in theory worked for Lord Umber, it never seemed that way in practice: She was quick to scold him in a loud and unpleasant tone on the wastefulness of his pursuits of all things magical and monstrous. “I’m still walking on air after seeing the giants,” Umber said, slumping out of sight below the carriage window. “I refuse to be brought to earth by one of Hoyle’s tirades right now. She’ll find me soon enough, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('em', [_vm._v("That’s true,")]), _vm._v(" Hap thought. Even he knew why Hoyle would be furious: Umber had commandeered the leviathan barge at a time when many of their merchant vessels were ruined by the storm. To Hoyle a lost business opportunity was more lamentable than the loss of a leg.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("The carriage tilted as the muscular horses hauled it up the causeway that led to the Aerie, the remarkable tower of hollow stone where Umber and his trusted friends lived. Hap felt as if tight bands of iron were springing loose from around his chest. ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("It was good to be away from the sea and back to the place he’d come to call home. If it were up to him, he’d never leave.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fl"
  }, [_vm._v("Lady Truden, the tall, silver-haired woman who ran the household of the Aerie, stood beside the open door with her hands clasped at her waist. “Welcome home, Lord Umber,” she said. Her smile settled into a thin horizontal line as she nodded to the others, and Hap thought one of her eyes twitched at the corner when she looked at him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They stepped onto the water-driven lift, which rattled and creaked toward the upper floors of the Aerie: the grand hall, the living quarters, and Umber’s rooftop tower.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m going to bed,” Oates announced through a yawn.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Of course you are, because you have the sleep habits of a cave bear,” Umber said. “But Sophie, my dear, please get to the studio while the images are fresh in your mind and commit them to paper. And Balfour, do you know what I could use?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“An ounce of common sense,” Oates suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Balfour dared a guess. “A pot of coffee?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Umber clapped his hands and stepped off the lift at the grand hall, where the kitchen lay ahead. “Just the thing!”")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/flower.jpg"
    }
  })])]), _c('p', {
    staticClass: "fl"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Hap kicked off his boots and flopped onto the small bed in his little room at the upper corner of the Aerie. It was a satisfying ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("thing, he decided, to lie down in your own bed after a journey—even if sleep was not your intent. He wrinkled his nose. The air in his room smelled stale, because the room had been kept shut in his absence. So he stood and opened the pair of windows that looked over Kurahaven and its harbor. The windows were like eyes in the truest sense, because they were set under the brow of a great face that was carved in the Aerie’s outer wall.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("As soon as he opened the window that faced the city, he heard the clatter of hooves and rumble of wheels on the causeway. He stuck his head into the breeze and saw a carriage. There was gilding on the wheels, and the driver wore the four-part coat of arms of the kingdom of Celador: the crown, the sun, the mountains, and a shell for the sea. Hap assumed it was a royal messenger until he saw a familiar head bob unsteadily out the window to gaze at the towering Aerie. It was Galbus, the middle prince.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hap sighed, knowing that he would have to stand by while Umber spoke to Prince Galbus. Umber was determined to keep Hap involved in any significant development; if Hap didn’t go of his own accord, Umber would summon him. "), _c('em', [_vm._v("It could be worse,")]), _vm._v(" Hap thought. Of the three princes he preferred by far the company of this one. The eldest, Argent, was dull and severe. And the youngest, Loden, while outwardly charming, filled Hap with unease.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("When Hap came down the steps to the grand hall, Galbus was gazing wide-eyed at the curiosities that filled the shelves. A figurine slipped from his hand, and he slowed its fall with the toe of his boot. He giggled, hiccuped, and fumbled it back on the shelf. Umber entered through the kitchen doors and smiled at his visitor.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Galbus, my friend! How good to see you! May I offer you some coffee?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Galbus returned the smile but wrinkled his nose. “You and your coffee, Umber—I don’t know how you can bear that bitter stuff. It’s wine for me, if you have it.” A silent belch inflated his cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Balfour emerged from the kitchen with a goblet before Umber could turn to call for it. Galbus drained half in a gulp. When he wiped his mouth, he saw Hap lurking by the stairs. “Happenstance! Come here, you mysterious imp. Let me get a look at those eyes!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The prince was a fun-loving fellow, but he had a tendency to treat Hap like some adorable but exotic pet. As he watched Hap approach, he looked a little disappointed that Hap didn’t arrive with one of the fantastic leaps of which he was capable. Nevertheless, Hap forced a smile and turned his face up for inspection as Galbus tousled his hair.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("“This visit is most welcome,” Umber said, coming to Hap’s rescue. “How can I serve you, my prince?”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Actually, I’m here with an invitation. My brothers are going on a hunt, and your company has been requested.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“A hunt, Your Highness?” Umber inhaled sharply between his teeth. “Forgive me, but I’ve never been fond of—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I know, I know, you don’t have the heart for the kill,” Galbus said, twirling his hands in the air. “But you’ll be interested in this hunt, because the prey is exotic.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Umber’s mouth puckered. “Is that so?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh, yes!” Galbus said, tipping the goblet for another long sip. “A creature they call the "), _c('em', [_vm._v("death-boar")]), _vm._v(" has apparently been seen in the mountains. The folk are terrified. Wooo!” He waggled his fingers in the air in mock fear. “Loden asked Argent and me to hunt the creature with him, as we used to hunt together in our youth.” Galbus hiccuped again, and wiped the corner of his mouth with his sleeve. “But it was not Loden’s idea that you come along. Argent has some things to discuss with you—serious matters, I presume,” Galbus added, with a look of disgust on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And will you be joining us, Galbus?”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Galbus snickered over the lip of the goblet. “Really, Umber. Everyone knows I am foolish and lazy. Do you expect me to risk that reputation? No, I will take ill tomorrow morning ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("when it is time to depart. After all, there are games to play and parties to plan.”")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Hap closed his eyes and sighed. He knew already that he would be dragged along on this unwelcome adventure; his future was written in the smile forming on Umber’s broad, toothy mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“This is tasty stuff,” Galbus said, tapping the goblet to shake the last drop into his mouth. “Do you have any more?”")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/flower.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fl"
  }, [_vm._v("At night, while the others slept, Hap wandered about the dark rooms of the Aerie. This was his time to explore the strange artifacts on its shelves and read the volumes of books that Umber had gathered from around the world. In the peaceful silence he liked to imagine that it was his domain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He picked up an item that was said to be a dragon’s claw. It was a piece of hollow bone the size and shape of a cow’s horn. As he ran his finger over its curved surface, he heard a small voice calling from below.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("“What, will you be down here every night now?” It was Thimble, the reclusive fellow who stood only a few inches high and dwelled inside the cracks and nooks of the Aerie. Thimble had no patience for “big folk,” as he called them, so Hap felt somewhat honored that the little fellow had actually spoken to him. Thimble scowled up at Hap while leaning ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("on his long spear, which had a glossy beetle impaled on its point.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Hap smiled. “Does it bother you if I am?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“More than a little,” Thimble replied, jutting his jaw. The beetle twitched, and its legs began to scramble. “Thought you were dead,” the little hunter complained. He flipped the spear, pinning the insect to the ground, and put his little boot on its belly. Then he lifted the spear and plunged it down again, into the poor thing’s head. The twitching ceased at once.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hap wrinkled his nose. “You don’t eat those, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What if I do?” Thimble asked, sneering back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A sour taste bubbled up Hap’s throat. “There’s better stuff in the kitchen. Balfour made berry pies today. …”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I "), _c('em', [_vm._v("know")]), _vm._v(" that,” Thimble said. “I can get some if I want.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m sure you can, but wouldn’t it be easier if I got it for you? Wait here,” Hap said. He jogged to the kitchen and brought back a heaping slice for himself and a spoonful for Thimble. It was a surprise to find Thimble still there when he got back, but he tried not to let it show. The little fellow fascinated him, and Hap wanted to keep this encounter going as long as he could. He sat on the floor with his legs crossed and put the spoon between them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thimble dug a hand into the spoonful and broke off a piece of berry-stained crust.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("“Good, isn’t it?” Hap said.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s all right,” Thimble replied, cramming as much into his mouth as he could fit. He swallowed and wiped his mouth with his sleeve. “You and I have something in common.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We do?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We’re both weird. Me ’cause I’m small. You ’cause … you’re just strange in so many ways.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hap couldn’t deny it. Whose story was as odd as his? He’d awoken weeks before in an underground city far away, with no memory of his previous life. The only clue to his identity was a note from the man who had left Hap for Umber to find. The note, signed with the initials WN, instructed Umber to take Hap with him on his adventures, and said that certain “skills” would arise. Those skills included the ability to see mysterious filaments of light that might someday allow him to steer the course of fate. For the moment, though, Hap had caught only fleeting glimpses of those threads and had no idea how to use them. This unusual power suggested that he belonged to a race of magical people called Meddlers—elusive beings who dabbled in human events for their own mysterious reasons.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What’s with you?” Thimble snapped.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Hap realized he’d fallen silent for a while, and that his face had settled into a deep frown under a furrowed brow. “Nothing,” he said quietly. Then he remembered which ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("way his thoughts had been headed. “Except … well, there’s something I’m supposed to do someday. For Umber. And I don’t know if I’ll ever be able to do it.”")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Save that other world, you mean?” Thimble asked. “The one Umber thinks he came from?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hap’s head rocked back. He’d forgotten what an accom-plished spy Thimble was, lurking in the crevices of the Aerie and listening to conversations nobody was supposed to hear. He cleared his throat. “Maybe.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thimble gathered as many crumbs as he could carry and stuffed them into his shirt. He pried the beetle off the point of his spear and kicked it away, no longer hungry. “Well, if it helps to know, I’m not sure you’ll be able to do it either.” He walked off with his shirt bulging and vanished in the crack of the wall that he called home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It doesn’t help at all, you little monster,” Hap finally replied, resting his chin on one hand.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ecf8ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 66
// module chunks = 0